import React, { Component } from 'react';
import { properties } from '../properties.js';
import Web3 from 'web3';
import Cookies from 'js-cookie';
import standard_abiA from '../../abis/Standard16A-abi.json';
import standard_abiB from '../../abis/Standard16B-abi.json';
import standard_abiC from '../../abis/Standard16C-abi.json';
import Navbar from "../LogInNavBar.js";
import Footer from "../Footer.js";
import { Carousel } from 'react-responsive-carousel';
import { withTranslation } from 'react-i18next';
import './css_16/userCertificate.css';
import i18n from '../I18N/I18n.js'; 
import ProductDetailsComponent from './ProductDetailsComponent.js';
import ComponenteMultimedia from './ComponenteMultimedia.js';
import { apiPublicRequest, apiSecuredRequest, checkFileType, cargarIdiomaPreferido} from '../functions.js';



class QRNftDisplay extends Component {


    async componentDidMount() {
        await cargarIdiomaPreferido(this.cambiarIdioma);
        await this.loadBrandFields()
        // 2. Carga de datos de la Blockchain
        await this.validateQRGeneratedUrl()

    }
   cambiarIdioma = (idioma) => {
       const { i18n } = this.props;
       i18n.changeLanguage(idioma); 
       this.forceUpdate(); 
       Cookies.set('idiomaPreferido', idioma, { expires: 365 });// Cambia el idioma usando i18n
     };

    async loadBrandFields() {
        let data = JSON.stringify({
            "email": `${properties.appUser}`,
            "password": `${properties.appPass}`
        });


        const bearerToken = await apiPublicRequest('post', `${properties.apiUrl}/certificat/api/usuario/login`, data);
        let urlParams = (new URL(document.location)).searchParams;
        const certificadoId = urlParams.get("certificadoId")
        let camposData = JSON.stringify({
            "certificadoId": `${certificadoId}`,
            "tipoStandard": `16CAMPOS`
        });
        const certificadoCompleto = await apiSecuredRequest('get', `${properties.apiUrl}/certificat/api/empresas/certificado/${certificadoId}`, "", bearerToken.data.accessToken);
        this.setState({certificadoCompleto: certificadoCompleto.data});

       

        const campos = await await apiSecuredRequest(
            'post', 
            `${properties.apiUrl}/certificat/api/campo/getCampos`, 
            camposData, 
            bearerToken.data.accessToken
        );


        
        

        this.setState({ campos: campos.data })
    }


    async validateQRGeneratedUrl() {
        let urlParams = (new URL(document.location)).searchParams;
        this.setState({ params: urlParams });
        let nombre;
        let apellido1;
        let apellido2;
        let email;
        let idProducto;
        let account;
        let documento;
        idProducto = urlParams.get("idProducto");
        account = urlParams.get("account");
        
        if (urlParams.has("nombre")) {
            nombre = urlParams.get("nombre");
          apellido1 = urlParams.get("apellido1");
          apellido2 = urlParams.get("apellido2");
          email = urlParams.get("email");
        
          documento = urlParams.get("documento");
          this.setState({showUserInfo: "true"});
        } else {
            nombre = "";
          apellido1 = "";
          apellido2 = "";
          email = "";
          documento = "";
        }

        const abi = standard_abiA;
        const abiB = standard_abiB;
        const abiC = standard_abiC
        console.log('abi', abi);
        const address = this.state.certificadoCompleto.direccion;
        const addressB = this.state.certificadoCompleto.direccion2;
        const addressC = this.state.certificadoCompleto.direccion3;
        const certificadoNombre = this.state.certificadoCompleto.certificado;
        if(abi && address && abiB && addressB && abiC && addressC) {
            try {
                var web3 = new Web3(new Web3.providers.HttpProvider(properties.web3Provider));
                const contract = new web3.eth.Contract(abi, address);
                const contractB = new web3.eth.Contract(abiB, addressB);
                const contractC = new web3.eth.Contract(abiC, addressC);
                this.setState({contractC});
                const validatedNFT = await contract.methods.getCertificateByIdProducto(idProducto).call({ from: account });
                
                if (urlParams.has("nombre")) {

                   
                


                    const hashValidation = await contract.methods.checkUserInfo(nombre, apellido1, apellido2, email, documento,
                        validatedNFT.campoA1,
                        validatedNFT.modelo,
                        validatedNFT.idProducto).call({ from: account });
    
                    if (hashValidation == false) {
                        Swal.fire({
                            icon: 'error',
                            title: `${i18n.t('incorrect')}`,
                            text: `${i18n.t('infoNotValidated')}`,
                            confirmButtonColor: '#196CF6',
                            confirmButtonText: 'Try Again'
                        });
                    } 
                    
                }
             
              

                    const validatedNFTB = await contractB.methods.getCertificateByIdProducto(idProducto).call({ from: account });
					const validatedNFTC = await contractC.methods.getCertificateByIdProducto(idProducto).call({ from: account });

                    let tipoArchivo1 = await checkFileType(validatedNFT.tokenUri);
                    
                    this.setState({ tipoArchivo1 });
                    
                    let tipoArchivo2 = validatedNFTB.tokenURI2 !== "" ? await checkFileType(validatedNFTB.tokenURI2) : "";
                    this.setState({ tipoArchivo2 });
                
                    let tipoArchivo3 = validatedNFTB.tokenURI3 !== "" ? await checkFileType(validatedNFTB.tokenURI3) : "";
                    this.setState({ tipoArchivo3 });
                   

                    this.setState({ nftURL: validatedNFT.tokenUri });
                    this.setState({ nombre });
                    this.setState({ apellido1 });
                    this.setState({ apellido2 });
                    this.setState({ documento });
                    this.setState({ email });
                    
                    this.setState({ account });
                    this.setState({ campoFecha: validatedNFT.campoFecha });
                    this.setState({ userInfo: validatedNFT.userInfo });
                    this.setState({ modelo: validatedNFT.modelo });
                    this.setState({ showData: true });
                    this.setState({ certificadoNombre: certificadoNombre });

                   const nftSeleccionadoVar = {
						id: validatedNFT.id,
						idProducto:  validatedNFT.idProducto,
						modelo: validatedNFT.modelo,
						descripcion: validatedNFT.descripcion,
						campoA1: validatedNFT.campoA1,
						userAddress: this.state.account,
						userInfo: validatedNFT.userInfo,
						campoFecha: validatedNFT.campoFecha,
						tokenUri: validatedNFT.tokenUri ,
						tokenUri2: validatedNFTB.tokenURI2,
						tokenUri3: validatedNFTB.tokenURI3,
						campo6: validatedNFTB.campo6,
						campo0: validatedNFTB.campo0,
						campo1: validatedNFTB.campo1,
						campo2: validatedNFTB.campo2,
						campo3: validatedNFTB.campo3,
						campo4: validatedNFTB.campo4,
						campo5: validatedNFTB.campo5,
						campo7: validatedNFTB.campo7,
						campo8: validatedNFTC.campo8,
						campo9: validatedNFTC.campo9,
						campo10: validatedNFTC.campo10,
						campo11: validatedNFTC.campo11,
						campo12: validatedNFTC.campo12,
						campo13: validatedNFTC.campo13,
						campo14: validatedNFTC.campo14,
						campo15: validatedNFTC.campo15
                        
					};
                    this.setState({fullNFT: nftSeleccionadoVar});
                    Swal.fire({
                        title: `${i18n.t('infoValidated')}`,
                        titleColor: '#FF0000',
                        icon: 'success',
                        confirmButtonColor: '#2B4570',
                        confirmButtonText: 'Close',
                    });
                    
                

            } catch (err) {
                this.setState({ errorMessage: err })
            } finally {
                this.setState({ loading: false })
            }
        }
    }

    async changePestania (pestania) {
		this.setState({ pestaniaSeleccionada: pestania });
	}

	async changePestaniaDetails (pestaniaDetails) {
            if(pestaniaDetails == 2) {
                if(this.state.modificaciones == null || !this.state.modificaciones.lenght > 0){
                    const modificaciones = await this.state.contractC.methods.obtenerModificacion(this.state.fullNFT.idProducto).call({ from: properties.proofUHostWallet });
                    this.setState({modificaciones: modificaciones});
                }
            }
            this.setState({ pestaniaDetails: pestaniaDetails });
    }

    async handleVideoClick (index) { 
		// Cambiar entre miniatura y vista completa
		setActiveVideo(activeVideo === index ? null : index);
	  };

      
    constructor(props) {
        super(props)
        this.state = {
            account: null,
            nombre: "",
            apellido1: null,
            apellido2: true,
            contractC: null,
			modificaciones: null,
            email: null,
            documento: null,
            tipoArchivo1: null,
            showUserInfo: "false",
			tipoArchivo2: null,
			tipoArchivo3: null,
            showData: false,
            userInfo: null,
            modelo: null,
            certificadoNombre: null,
            nftURL: null,
            campos: null,
            empresa: null,
            pestaniaSeleccionada: 1,
			pestaniaDetails: 1,
            fullNFT: null,
            agregarModificacion: "false",
        };
        this.changePestania = this.changePestania.bind(this),
		this.changePestaniaDetails = this.changePestaniaDetails.bind(this)
    }

    render() {
        if (this.state.fullNFT != null && this.state.certificadoNombre != null) {
            const campoA1 = this.state.campos.filter(campo => campo.orden == "CAMPO1A")[0].nombreCampo;
				const campoFecha = this.state.campos.filter(campo => campo.orden == "FECHA")[0].nombreCampo;
				const idProducto = this.state.campos.filter(campo => campo.orden == "IDPRODUCTO")[0].nombreCampo;
            return (
                <>
                    <Navbar mail={this.state.email} cambiarIdioma = {this.cambiarIdioma} />

                    <div className="nft_display_16">

<p onClick={(event) => { window.location.href = `/${this.state.empresaMapping}/standard16/userCertificateList?certificadoId=${this.state.certificadoId}&certificadoName=${this.state.certificadoName}` }} className="menu_brandName_16"><span>{this.state.empresaName} /</span>
    <button onClick={(event) => { window.location.href = `/standard16/listaEmpresas` }} className="allBrands_btn_16">{i18n.t('AllCertificates')}</button></p>
    
    <ComponenteMultimedia
										tipoArchivo1={this.state.tipoArchivo1}
										tipoArchivo2={this.state.tipoArchivo2}
										tipoArchivo3={this.state.tipoArchivo3}
										pestaniaSeleccionada = {this.state.pestaniaSeleccionada}
										changePestania = {this.changePestania}
									/>                                                                                                  
                      

<div className="content_info_16">

    <p className="product_model_16">{this.state.modelo}</p>
    

  {this.state.showUserInfo = "true " && ( <div className="details_container_16">
        <div className="certificateData_card_1">
            <p className="titleCard_16">{i18n.t('CertificateData')}</p>
            <table className="productDetails_table_16">
                
                    <tr>
                        <th className="details_th_16">{i18n.t('Name')}:</th>
                        <td className="details_td_16">{this.state.nombre}</td>
                    </tr>
                    <tr>
                        <th className="details_th_16">{i18n.t('Surname')}:</th>
                        <td className="details_td_16">{this.state.apellido1}&nbsp;{this.state.apellido2}</td>
                    </tr>

                    <tr>
                        <th className="details_th_16">{i18n.t('Email')}:</th>
                        <td className="details_td_16">{this.state.email}</td>
                    </tr>

                    <tr>
                        <th className="details_th_16">{i18n.t('documento')}:</th>
					    <td className="details_td_16">{this.state.documento}</td>
					</tr>								
                    <tr>
                        <th className="details_th_16">{i18n.t('WalletAddress')}:</th>
                        <td className="details_td_16"><a className="product_walletAdress_16" href='https://etherscan.io/address/${account}'>{this.state.account}</a></td>
                    </tr>
                    <tr>
                        <th className="details_th_16">{i18n.t('UserHash')}</th>
                        <td className="details_td_16">{this.state.userInfo}</td>
                    </tr>
            </table>
        </div>

       
    </div> )}

    <ProductDetailsComponent
											userNft={this.state.fullNFT}
											campos={this.state.campos}
											idProducto={this.state.idProducto}
											campoFecha={this.state.campoFecha}
											campoA1={this.state.campoA1}
											pestaniaDetails = {this.state.pestaniaDetails}
											changePestaniaDetails = {this.changePestaniaDetails}
                                            modificaciones = {this.state.modificaciones}
                                            agregarModificacion = {this.state.agregarModificacion}
										/>


    <div className="description_container_16">
        <p className="titleCard_16">{i18n.t('description')}</p>
        <p class="product_description_16">{this.state.fullNFT.descripcion}</p>
    </div>
</div>
</div>

<Footer />
                </>
            );

        } else {
            <h1>Loading</h1>
        }


    }
}

export default  withTranslation()(QRNftDisplay);
